import type { QueryClient } from '@tanstack/react-query';

import { commitConfirmedDashboardConfig, dashboardOptions } from '@/features/dashboard';
import type { DashboardConfig } from '@/features/dashboard';

import type { CreateDashboardTabParams } from './symbol-selector.api';
import { createDashboardTab } from './symbol-selector.api';

export function createDashboardTabMutationOptions(
  queryClient: QueryClient,
  onNavigate: (dashboardName: string, tabName: string) => void
) {
  return {
    mutationKey: dashboardOptions.mutations.addWidget(),
    mutationFn: createDashboardTab,
    onSuccess: (
      dashboards: DashboardConfig,
      { dashboardName, tabName }: CreateDashboardTabParams
    ) => {
      commitConfirmedDashboardConfig(queryClient, dashboards);
      onNavigate(dashboardName, tabName);
    },
    onError: () => {}
  };
}
